import { gql } from '@apollo/client'

export const GET_LABEL_STORYGUIDE = gql`
  query {
    getLabelStoryGuide {
      id
      template_type
      template
      label_id
    }
  }
`
